// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 7662) return "static/chunks/7662.e6dcf292fc4a3077.js";
	if (chunkId === 5949) return "static/chunks/5949.eec73159e888cea3.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"1630":"2d80f1ddf67f3068","7782":"78af8cdceb0278b4","8615":"ddb10f26133d4580"}[chunkId] + ".js";
};